import { MenuBook } from '@mui/icons-material'
import {
  darken,
  lighten,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  useTheme,
} from '@mui/material'

import useIsPartner from '~/features/partners/hooks/useIsPartner'
import { SIDE_NAV_GUIDANCE_ITEM_CLASS_NAME } from '~/layouts/account/header/nav/side/constants'
import { ENavItemNames } from '~/layouts/account/models'
import rem from '~/utils/ui'

type TProps = {
  onOpen: () => void
}

function GuidanceItem({ onOpen }: TProps) {
  const isPartner = useIsPartner()
  const theme = useTheme()

  return (
    <Stack
      spacing={0}
      onClick={onOpen}
      sx={{
        textDecoration: 'none',
        textAlign: 'center',
        color: theme.palette.menuFont,

        '& .MuiButtonBase-root': {
          marginBottom: rem(8),
          px: rem(10),

          '&:hover svg': isPartner
            ? darken(theme.palette.menuIcon, 0.4)
            : theme.palette.common.white,
        },
        '& .MuiListItemButton-root': {
          py: 0,
        },
        '& .MuiListItemText-root': {
          my: 0,
        },
        '& .MuiListItemText-primary': {
          ml: 1,
          textAlign: 'left',
          whiteSpace: 'nowrap',
        },
        '& .MuiTypography-root': {
          ml: rem(12),
          fontWeight: '300',
          letterSpacing: rem(2),
          fontSize: rem(14),
          lineHeight: rem(34),
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      }}
    >
      <ListItem disablePadding>
        <ListItemButton
          className={SIDE_NAV_GUIDANCE_ITEM_CLASS_NAME}
          sx={{
            border: `1px solid ${theme.palette.tertiary1}`,
            mr: 2,
            '&.active': {
              '.MuiTypography-root': {
                fontWeight: 'bold',
              },
              '& svg': {
                fill: isPartner
                  ? darken(theme.palette.menuFont, 0.4)
                  : theme.palette.menuFont,
              },
              '& > svg': {
                width: rem(23),
                height: rem(23),
                fill: isPartner
                  ? darken(theme.palette.menuFont, 0.4)
                  : theme.palette.menuFont,
                marginTop: rem(-2),
              },
            },
            '&:hover': {
              borderColor: lighten(theme.palette.tertiary1, 0.1),
            },
            '&:hover svg': {
              fill: isPartner
                ? darken(theme.palette.menuFont, 0.4)
                : theme.palette.menuFont,
            },
            borderRadius: 2,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 'auto',
              color: theme.palette.menuFont,
              flexGrow: 0,
              width: rem(19),
              overflow: 'hidden',
              marginTop: rem(-2),
            }}
          >
            <MenuBook
              sx={{ width: rem(23), height: rem(23), marginLeft: rem(-3) }}
            />
          </ListItemIcon>
          <ListItemText
            primary={ENavItemNames.guidance}
            primaryTypographyProps={{
              sx: { display: 'inline-flex' },
            }}
            secondaryTypographyProps={{
              component: 'span',
              sx: {
                color: theme.palette.menuIcon,
                textTransform: 'lowercase',
                display: 'inline-flex',
              },
            }}
          />
        </ListItemButton>
      </ListItem>
    </Stack>
  )
}

export default GuidanceItem
